export default __webpack_public_path__ + "static/media/push-pin 2.82d2934a.svg";